(ns heraldicon.frontend.component.entity.arms.data
  (:require
   [heraldicon.frontend.component.core :as component]))

(defmethod component/form :heraldicon.entity.arms/data [_context]
  nil)
